import {useSignals} from '@preact/signals-react/runtime'
import {ConfirmPopup} from 'primereact/confirmpopup'
import {Divider} from 'primereact/divider'
import {useRef} from 'react'
import {ReactComponent as DuoUserPrivate} from '../../../assets/icons/DuoUserPrivate.svg'
import TranslateUtils from '../../../i18n/TranslateUtils'
import GenericLogTable from '../../generic-log/GenericLogTable'
import StyledTitle from '../../layout/StyledTitle'
import RelevantContactCard from '../next-of-kin/RelevantContactCard'
import {usePatientContext} from './StyleDetailInformationWrapper'
import StyledAdditionalInformationSection from './StyledAdditionalInformationSection'
import StyledBasicDetailInformationSection from './StyledBasicDetailInformationSection'
import StyledContactInformationSection from './StyledContactInformationSection'
import StyledGeneralPractitionerInformationSection from './StyledGeneralPractitionerInformationSection'
const StyledDetailInformationTabView = () => {
    useSignals()
    //#region Context
    const {currentViewedUser} = usePatientContext()
    //#endregion

    //#region Translate
    const {translateCommons, translateDatatable} = TranslateUtils()
    //#endregion

    //#region State
    //#endregion

    //#region Ref
    const genericRef = useRef(null)
    //#endregion

    return (
        <div className="w-full">
            <div className="w-full">
                {/* {currentViewedUser?.systemRole &&
                    currentViewedUser?.systemRole === SystemRole.USER && (
                        <React.Fragment>
                            <ul className="m-0 p-0">
                                <li className="flex mb-1 border-round justify-content-center align-items-center py-3 px-2 flex-wrap  ">
                                    <h5
                                        className={`pl-2 text-black font-bold w-full m-0 py-2 text-center  md:text-left`}>
                                        <span className="mr-3">
                                            <i className="pi pi-user font-bold text-xl"></i>
                                        </span>
                                        {translateCommons(
                                            "Patient's Information Audit Log",
                                        )}
                                    </h5>
                                </li>

                                <li className="flex align-items-center py-3 flex-wrap col-12">
                                    <div
                                        className={`col-12 m-0 p-0 flex gap-2 flex-column md:flex-row align-items-center justify-content-center md:justify-content-between`}>
                                        <i className="underline m-0  text-700">
                                            {translateCommons(
                                                "The audit log shows various changes in patient's account since the account was created. It saves a record of these changes indefinitely, and you can view the entire change history.",
                                            )}
                                        </i>
                                        <div>
                                            <Button
                                                className="gap-1 w-13rem px-3 bg-gray-700 hover:bg-gray-900 text-white border-0"
                                                icon="pi pi-download"
                                                label={translateCommons(
                                                    'Show Audit Log ',
                                                )}
                                                onClick={() =>
                                                    !!currentViewedUser?.id &&
                                                    genericRef.current.showForm(
                                                        {
                                                            refId: currentViewedUser?.id,
                                                            type: 'userLog',
                                                        },
                                                    )
                                                }
                                            />
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </React.Fragment>
                    )} */}
            </div>
            <Divider type="dashed" />
            <div className="grid">
                <div className="md:col-6 col-12 md:px-4 p-0">
                    <StyledBasicDetailInformationSection />
                </div>
                <div className="md:col-6 col-12 md:px-4 p-0">
                    <StyledAdditionalInformationSection />
                </div>
            </div>

            <Divider type="dashed" />

            <StyledContactInformationSection />
            <Divider type="dashed" />
            <StyledGeneralPractitionerInformationSection />

            <Divider type="dashed" />
            <StyledTitle
                title={translateCommons('Relevant Contact')}
                showAdd={true}
                description="Resident’s relevant family contacts"
                icon={<DuoUserPrivate />}
            />

            {/* <StyledRelevantContactDatatable /> */}

            <RelevantContactCard />

            <ConfirmPopup />
            <GenericLogTable ref={genericRef} />
        </div>
    )
}

export default StyledDetailInformationTabView
